import { NgModule } from '@angular/core';

import { SharedModule } from "../shared/shared.module";
import { CombustiveisModule } from "./combustiveis/combustiveis.module";
import { LocaisModule } from "./locais/locais.module";
import { BombasModule } from "./bombas/bombas.module";
import { AbastecimentoBensModule } from "./abastecimento-bens/abastecimento-bens.module";
import { AbastecimentoConfiguracaoComponent } from "./configuracao/abastecimento-configuracao.component";
import { AbastecimentosRoutingModule } from "./abastecimentos-routing.module";
import { AbastecimentosComponent } from "./abastecimentos.component";
import { AbastecimentoMenuComponent } from "./shared/abastecimento-menu/abastecimento-menu.component";
import { AbastecimentoService } from "./shared/abastecimento.service";
import { TanquesModule } from "./tanques/tanques.module";
import { TipoAjustesModule } from "./tipo-ajustes/tipo-ajustes.module";
import { AbastecimentoRelatorioComponent } from "./relatorios/abastecimento-relatorio.component";

@NgModule({
    imports: [
        SharedModule,
        CombustiveisModule,
        LocaisModule,
        BombasModule,
        AbastecimentoBensModule,
        TanquesModule,
        TipoAjustesModule,
        AbastecimentosRoutingModule
    ],
    providers: [
        AbastecimentoService,
    ],
    declarations: [
        AbastecimentosComponent,
        AbastecimentoConfiguracaoComponent,
        AbastecimentoMenuComponent,
        AbastecimentoRelatorioComponent
    ],
    exports: [
        AbastecimentoMenuComponent
    ]
})
export class AbastecimentosModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/abastecimentos.module.ts
 **/